
import GwTrainerList from '~/patterns/organisms/trainer-list/trainer-list';

export default {
    components: {
        GwTrainerList,
    },

    props: {
        heading: {
            type: String,
            required: false,
            default: null
        },
        trainers: {
            type: Array,
            required: true,
            default: () => { return []; },
        }
    }
};
